var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightTestimonial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.918,
    height: 46.002,
    viewBox: "0 0 24.918 46.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_chevron_right_3",
    d: "M14.751,49H10.917A1.917,1.917,0,0,1,9.434,45.87L25.692,26,9.434,6.13A1.916,1.916,0,0,1,10.917,3h3.834a1.918,1.918,0,0,1,1.484.7L33.485,24.788a1.92,1.92,0,0,1,0,2.429L16.234,48.3A1.922,1.922,0,0,1,14.751,49Z",
    transform: "translate(-8.999 -3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightTestimonial);
export default __webpack_public_path__ + "static/media/arrow-right-testimonial.3fb583f5.svg";
export { ForwardRef as ReactComponent };